<template>
  <v-card>
    <v-tabs
      v-model="tab"
      show-arrows
    >
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiClipboardOutline }}
        </v-icon>
        <span>Данные</span>
      </v-tab>

      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiTimelineClockOutline }}
        </v-icon>
        <span>Статусы</span>
      </v-tab>

      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiContactlessPayment }}
        </v-icon>
        <span>Workflow</span>
      </v-tab>

      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiCashCheck }}
        </v-icon>
        <span>Оплата</span>
      </v-tab>

      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiSwapHorizontal }}
        </v-icon>
        <span>Delivery</span>
      </v-tab>

      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiBankOutline }}
        </v-icon>
        <span>Bakai</span>
      </v-tab>

      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiCashRegister }}
        </v-icon>
        <span>Касса и CRM</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <order-form></order-form>
      </v-tab-item>
      <v-tab-item>
        <order-status-history></order-status-history>
      </v-tab-item>
      <v-tab-item>
        <order-workflow></order-workflow>
      </v-tab-item>
      <v-tab-item>
        <order-payment-log></order-payment-log>
      </v-tab-item>
      <v-tab-item>
        <order-delivery-log></order-delivery-log>
      </v-tab-item>
      <v-tab-item>
        <order-bakai-log></order-bakai-log>
      </v-tab-item>
      <v-tab-item>
        <order-integration-log></order-integration-log>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import {
  mdiClipboardOutline,
  mdiTimelineClockOutline,
  mdiContactlessPayment,
  mdiCashCheck,
  mdiSwapHorizontal,
  mdiBankOutline,
  mdiCashRegister,
} from '@mdi/js'
import OrderForm from '@/views/order/order-form.vue'
import OrderStatusHistory from '@/views/order/order-status-history.vue'
import OrderWorkflow from '@/views/order/order-workflow.vue'
import OrderPaymentLog from '@/views/order/order-payment-log.vue'
import OrderDeliveryLog from '@/views/order/order-delivery-log.vue'
import OrderBakaiLog from '@/views/order/order-bakai-log.vue'
import OrderIntegrationLog from '@/views/order/order-integration-log.vue'

export default {
  name: 'OrderFormTab',
  components: {
    OrderWorkflow,
    OrderForm,
    OrderStatusHistory,
    OrderPaymentLog,
    OrderDeliveryLog,
    OrderBakaiLog,
    OrderIntegrationLog,
  },
  data: () => ({
    icons: {
      mdiClipboardOutline,
      mdiTimelineClockOutline,
      mdiContactlessPayment,
      mdiCashCheck,
      mdiSwapHorizontal,
      mdiBankOutline,
      mdiCashRegister,
    },
    tab: null,
  }),
}
</script>
